/* Minimal Gamers — mobile fix layer (07-10-2026)
   1) Autoplay per il carosello Unboxing su mobile
      (si ferma quando l'utente tocca il carosello e riparte dopo qualche secondo).
   2) Foto prodotto uniformi su TUTTO il sito (home, collezioni, ricerca, schede prodotto,
      correlati, carrello): ogni foto viene misurata (bordo trasparente/vuoto escluso)
      e scalata/centrata in modo che tutti i prodotti occupino lo stesso spazio nel riquadro.
      È una regola, non una lista: vale da sola per prodotti nuovi, foto nuove e qualsiasi ordine.
      Le foto "ambientate" (sfondo pieno) vengono riconosciute e lasciate com'erano.
   3) Collezioni: la barra categorie orizzontale mostra subito la categoria attiva. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 749px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------------- 1. Autoplay caroselli ---------------- */
  function setupAutoplay(track, opts) {
    if (!track || track.__mgAuto) return;
    track.__mgAuto = true;
    var visible = false;
    var pausedUntil = 0;

    function step() {
      if (!mq.matches || !visible || Date.now() < pausedUntil || document.hidden) return;
      var item = track.querySelector(opts.item);
      if (!item) return;
      var gap = parseFloat(getComputedStyle(track.querySelector(opts.gapFrom) || track).columnGap) || 0;
      var delta = item.getBoundingClientRect().width + gap;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 4) return;
      if (track.scrollLeft + delta > max - 4) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: delta, behavior: 'smooth' });
      }
    }

    function pause() { pausedUntil = Date.now() + (opts.resumeAfter || 7000); }
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, pause, { passive: true });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }, { threshold: 0.35 }).observe(track);
    } else {
      visible = true;
    }
    setInterval(step, opts.interval || 3800);
  }

  var targets = [
    { track: '.mg-community-wall__viewport', item: '.mg-community-wall__track > article', gapFrom: '.mg-community-wall__track', interval: 3200 }
  ];

  function scanAutoplay() {
    if (reduce.matches) return;
    targets.forEach(function (t) {
      var el = document.querySelector(t.track);
      if (el) setupAutoplay(el, t);
    });
  }

  /* ---------------- 2. Foto prodotto uniformi (tutto il sito) ---------------- */
  var IMG_SELECTOR = [
    '#pc-gaming .product-visual img',            // home: carosello PC
    '.community-build-visual img',               // home: build della community
    '.mg-cat-card-visual img',                   // collezioni PC + ricerca
    '.mg-category-links figure img',             // collezioni monitor/notebook/periferiche + ricerca
    '.mg-rex-hero__visual img',                  // scheda PC: foto principale
    '.mg-rex-crosssell__track img',              // scheda PC: abbinamenti
    '.mg-standard-gallery__main img',            // scheda prodotto standard: foto principale
    '.mg-standard-related figure img',           // scheda prodotto standard: correlati
    '.cart-item-media img',                      // carrello
    'a[href*="/products/"] img'                  // qualsiasi altra card prodotto
  ].join(',');
  // zone dove NON intervenire (loghi, foto ambientate, video social, tile hero)
  var EXCLUDE = 'header, footer, .mg-header-shell, .mg-smart-footer, .journey-card, .mg-community-wall, .mg-social-stage, .mg-brand';
  var FILL = 0.94;            // quanto spazio del riquadro occupa il prodotto
  var MAX_SCALE = 2.2;
  var MIN_SIZE = 56;          // sotto questa misura (icone) non si tocca nulla
  var boxCache = {};          // src -> {x0,y0,x1,y1,opaque} in frazioni dell'immagine, o null
  var waiting = {};

  function analysisUrl(src) {
    // versione piccola della stessa foto (basta per misurare i bordi)
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1160');
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=160';
  }

  function measure(src, cb) {
    if (Object.prototype.hasOwnProperty.call(boxCache, src)) { cb(boxCache[src]); return; }
    if (waiting[src]) { waiting[src].push(cb); return; }
    waiting[src] = [cb];
    var done = function (res) {
      boxCache[src] = res;
      var list = waiting[src] || []; delete waiting[src];
      list.forEach(function (fn) { fn(res); });
    };
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.decoding = 'async';
    im.onload = function () {
      try {
        var w = im.naturalWidth, h = im.naturalHeight;
        if (!w || !h) { done(null); return; }
        var k = 160 / Math.max(w, h);
        var cw = Math.max(1, Math.round(w * k)), ch = Math.max(1, Math.round(h * k));
        var c = document.createElement('canvas'); c.width = cw; c.height = ch;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(im, 0, 0, cw, ch);
        var d = ctx.getImageData(0, 0, cw, ch).data;
        var corners = [0, (cw - 1) * 4, (ch - 1) * cw * 4, (ch * cw - 1) * 4];
        var alphaMode = corners.some(function (i) { return d[i + 3] < 250; });
        var r0 = d[0], g0 = d[1], b0 = d[2];
        var minX = cw, minY = ch, maxX = -1, maxY = -1;
        for (var y = 0; y < ch; y++) {
          for (var x = 0; x < cw; x++) {
            var i = (y * cw + x) * 4;
            var on = alphaMode
              ? d[i + 3] > 28
              : (Math.abs(d[i] - r0) + Math.abs(d[i + 1] - g0) + Math.abs(d[i + 2] - b0)) > 54;
            if (on) {
              if (x < minX) minX = x; if (x > maxX) maxX = x;
              if (y < minY) minY = y; if (y > maxY) maxY = y;
            }
          }
        }
        if (maxX < 0) { done(null); return; }
        var box = { x0: minX / cw, y0: minY / ch, x1: (maxX + 1) / cw, y1: (maxY + 1) / ch, opaque: !alphaMode };
        // foto "piena" (ambientata o già ritagliata al bordo): si lascia com'è
        if (box.x1 - box.x0 >= 0.92 && box.y1 - box.y0 >= 0.92) { done(null); return; }
        done(box);
      } catch (e) { done(null); }
    };
    im.onerror = function () { done(null); };
    im.src = analysisUrl(src);
  }

  function clear(img) {
    img.style.removeProperty('transform');
    img.style.removeProperty('transform-origin');
    img.style.removeProperty('clip-path');
    img.__mgFit = null;
  }

  function fit(img) {
    if (!mq.matches) { if (img.__mgFit) clear(img); return; }
    if (img.closest(EXCLUDE)) return;
    var src = img.currentSrc || img.src;
    if (!src || src.indexOf('data:') === 0) return;
    if (!img.complete || !img.naturalWidth) {
      if (!img.__mgWait) {
        img.__mgWait = true;
        img.addEventListener('load', function () { img.__mgWait = false; fit(img); }, { once: true });
      }
      return;
    }
    var W = img.clientWidth, H = img.clientHeight;
    if (W < MIN_SIZE || H < MIN_SIZE) return;
    var key = src + '|' + W + 'x' + H;
    if (img.__mgFit === key) return;
    measure(src, function (bb) {
      if (!bb) { if (img.__mgFit) clear(img); img.__mgFit = key; return; }
      var W2 = img.clientWidth, H2 = img.clientHeight;
      if (!W2 || !H2) return;
      var cs = getComputedStyle(img);
      var fitMode = cs.objectFit;
      if (fitMode === 'fill') return;
      var pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0;
      var pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
      var CW = W2 - pl - pr, CH = H2 - pt - pb;           // area in cui il browser disegna la foto
      if (CW < 4 || CH < 4) return;
      var nw = img.naturalWidth, nh = img.naturalHeight;
      var s0 = fitMode === 'cover' ? Math.max(CW / nw, CH / nh) : Math.min(CW / nw, CH / nh);
      var dw = nw * s0, dh = nh * s0;
      var ox = pl + (CW - dw) / 2, oy = pt + (CH - dh) / 2;
      var cx0 = ox + bb.x0 * dw, cx1 = ox + bb.x1 * dw;
      var cy0 = oy + bb.y0 * dh, cy1 = oy + bb.y1 * dh;
      var cW = cx1 - cx0, cH = cy1 - cy0;
      if (cW < 4 || cH < 4) return;
      var s = Math.min(W2 * FILL / cW, H2 * FILL / cH);
      s = Math.max(0.5, Math.min(s, MAX_SCALE));
      var cx = W2 / 2, cy = H2 / 2;
      var tx = -((cx0 + cx1) / 2 - cx) * s;
      var ty = -((cy0 + cy1) / 2 - cy) * s;
      img.style.setProperty('transform-origin', '50% 50%', 'important');
      img.style.setProperty('transform', 'translate(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px) scale(' + s.toFixed(3) + ')', 'important');
      if (bb.opaque && s > 1) {
        // foto con sfondo pieno: lo sfondo ingrandito resta dentro il riquadro originale
        var l = Math.max(0, cx - (cx + tx) / s), r = Math.max(0, cx - (cx - tx) / s);
        var t = Math.max(0, cy - (cy + ty) / s), b = Math.max(0, cy - (cy - ty) / s);
        img.style.setProperty('clip-path', 'inset(' + t.toFixed(1) + 'px ' + r.toFixed(1) + 'px ' + b.toFixed(1) + 'px ' + l.toFixed(1) + 'px)', 'important');
      } else {
        img.style.removeProperty('clip-path');
      }
      img.__mgFit = src + '|' + W2 + 'x' + H2;
    });
  }

  var ro = ('ResizeObserver' in window) ? new ResizeObserver(function (entries) {
    entries.forEach(function (en) { fit(en.target); });
  }) : null;

  function fitAll() {
    var list = document.querySelectorAll(IMG_SELECTOR);
    for (var i = 0; i < list.length; i++) {
      var img = list[i];
      if (ro && !img.__mgObs) { img.__mgObs = true; ro.observe(img); }
      fit(img);
    }
  }

  var pending = null;
  function scheduleFitAll() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; fitAll(); scanAutoplay(); focusTierDock(); }, 150);
  }

  /* ---------------- 3. Barra categorie collezioni ---------------- */
  function focusTierDock() {
    var dock = document.querySelector('.mg-cat-tier-dock');
    if (!dock || dock.__mgFocused || !mq.matches) return;
    var active = dock.querySelector('[aria-current]');
    if (!active || dock.scrollWidth <= dock.clientWidth) return;
    dock.__mgFocused = true;
    var left = active.offsetLeft - dock.offsetLeft - 8;
    dock.scrollLeft = Math.max(0, left);
  }

  window.addEventListener('resize', scheduleFitAll);
  if (mq.addEventListener) mq.addEventListener('change', scheduleFitAll);
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.matches && t.matches(IMG_SELECTOR)) fit(t);
  }, true);

  function start() {
    fitAll(); scanAutoplay(); focusTierDock();
    if ('MutationObserver' in window) {
      // la home (React), la ricerca e il carrello cambiano la pagina dopo il caricamento
      new MutationObserver(scheduleFitAll).observe(document.body, { childList: true, subtree: true });
    }
    var runs = 0;
    (function poll() { scheduleFitAll(); if (++runs < 12) setTimeout(poll, 1000); })();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
